import { defineComponent, ref } from 'vue';
import { PictureFilled } from '@element-plus/icons-vue';

const icons = {
  PictureFilled,
};

export default defineComponent({
  name: 'FallbackImage',
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const isImageError = ref(false);

    const imageError = () => {
      isImageError.value = true;
    };

    return {
      isImageError,
      imageError,
      icons,
    };
  },
});
